import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { AlertTriangle, HelpCircle, Lightbulb, ArrowDown } from "lucide-react";
import api from "@/lib/api";
import { useSite } from "@/context/SiteContext";
import { Button } from "@/components/ui/button";
import ProductCard from "@/components/ProductCard";
import { PageHero } from "@/components/Bits";

export default function ApplicationDetail() {
  const { slug } = useParams();
  const { openQuote } = useSite();
  const [data, setData] = useState(null);

  useEffect(() => {
    setData(null);
    window.scrollTo(0, 0);
    api.get(`/applications/${slug}`).then((r) => setData(r.data)).catch(() => setData({ error: true }));
  }, [slug]);

  if (!data) return <div className="mx-auto max-w-[1400px] px-4 py-32 text-[#A1A1AA] lg:px-8">Carregando...</div>;
  if (data.error) return <div className="mx-auto max-w-[1400px] px-4 py-32 lg:px-8"><h1 className="font-heading text-2xl text-white">Aplicação não encontrada</h1></div>;

  const { application: a, products } = data;
  const flow = [
    { icon: AlertTriangle, t: "Problema", d: a.problem, c: "#FF5500" },
    { icon: HelpCircle, t: "Necessidade", d: a.need, c: "#007AFF" },
    { icon: Lightbulb, t: "Solução", d: a.solution, c: "#22c55e" },
  ];

  return (
    <div>
      <PageHero eyebrow="Aplicação" title={a.name} image={a.image} />
      <div className="mx-auto max-w-[1400px] px-4 py-16 lg:px-8">
        <div className="space-y-4">
          {flow.map((f, i) => (
            <div key={f.t}>
              <div className="flex items-start gap-4 border border-[#27272A] bg-[#151618] p-6">
                <f.icon className="h-7 w-7 shrink-0" style={{ color: f.c }} />
                <div>
                  <div className="label-eyebrow" style={{ color: f.c }}>{f.t}</div>
                  <p className="mt-1 text-white">{f.d}</p>
                </div>
              </div>
              {i < flow.length - 1 && <div className="flex justify-center py-2"><ArrowDown className="h-5 w-5 text-[#3f3f46]" /></div>}
            </div>
          ))}
        </div>

        <div className="mt-8 flex flex-wrap gap-3">
          <Button data-testid="app-dimension-button" onClick={() => openQuote({ application: a.name, source: `aplicacao:${a.slug}` })}
            className="rounded-none bg-[#FF5500] px-8 py-6 text-base font-bold hover:bg-[#CC4400]">Solicitar Dimensionamento</Button>
        </div>

        {products.length > 0 && (
          <div className="mt-16">
            <h2 className="font-heading mb-8 text-2xl font-bold text-white">Equipamentos recomendados</h2>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
              {products.map((p) => <ProductCard key={p.slug} product={p} />)}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
